export default {
  INVALID_CARD_NUMBER: 1001,
  INVALID_ACTIVATION_CODE: 1002,
  INVALID_SMS_CODE: 1004,
  ERROR_ATTEMPT_LIMIT: 1008,
  ERROR_CARD_ALREADY_ACTIVATED: 1009,
  ERROR_INVALID_EMAIL: 1011,
  ERROR_EMAIL_EXISTS: 1012,
  INVALID_BIRTHDAY: 1014,
  ERROR_INVALID_PASSWORD: 1016,
  MISSING_USER: 10022,
  TOO_MANY_REQUESTS: 10023,
  TOO_MANY_ATTEMPTS: 10024,
  INVALID_UNIQUE_KEY: 10025,
  INVALID_VERIFICATION_CODE: 10026,
  MIXED_PARAMS: 10027,
  INVALID_PASSWORD: 10028,
  EMAIL_NOT_CONFIRMED: 10029,
  ERROR_EMAIL_SENDING_TIMEOUT: 1020,
  UNKNOWN_SERVER_ERROR: 1000,
  INVALID_USER_OR_PASSWORD: 1021,
  USER_NOT_FOUND: 1022,
  USER_IS_BLOCKED: 1023,
  PHONE_EXISTS: 1024,
  PASSWORD_RESTORATION_REQUIRED: 1025,
  EMAIL_SENDER_ERROR: 10032,
  ERROR_EMAIL_OR_PASSWORD_NOT_FOUND: 10034,
  ERROR_PHONE_NUMBER_OR_PASSWORD_NOT_FOUND: 10035,
  ERROR_CARD_NUMBER_OR_PASSWORD_NOT_FOUND: 10036,
  ERROR_INVALID_USERNAME: 10037,
  ERROR_FOREIGN_EMAIL: 1027,

  INVALID_IDENTIFIER: 'INVALID_IDENTIFIER',
};
